module.exports = __webpack_public_path__ + "img/natochiy-s.a4763b56.jpg";